// Updated NewMeditation.js with category dropdown

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateMeditationConfigMutation } from './meditationApi';
import { Form, Button } from 'react-bootstrap';

const categoryOptions = [
  { label: 'Meditation', value: 'meditation' },
  { label: 'Satsang', value: 'satsang' },
  { label: 'Private Meeting', value: 'privateMeeting' },
];

const NewMeditation = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [zoomUrl, setZoomUrl] = useState('');
  const [type, setType] = useState('AudioOnly');
  const [dayOfWeek, setDayOfWeek] = useState('Sunday');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [category, setCategory] = useState('');

  const navigate = useNavigate();
  const [createConfig] = useCreateMeditationConfigMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    await createConfig({
      name,
      description,
      audioUrl,
      zoomUrl,
      type,
      dayOfWeek,
      startTime,
      endTime,
      category,
    });

    navigate('/dashboard/meditation');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <h2 className="mb-4 text-center">New Meditation Configuration</h2>
      <Form.Group className="mb-3" controlId="name">
        <Form.Label>Name:</Form.Label>
        <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
      </Form.Group>

      <Form.Group className="mb-3" controlId="description">
        <Form.Label>Description:</Form.Label>
        <Form.Control type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3" controlId="category">
        <Form.Label>Category:</Form.Label>
        <Form.Select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          required
        >
          <option value="">Select Category</option>
          {categoryOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="audioUrl">
        <Form.Label>Audio URL:</Form.Label>
        <Form.Control type="text" value={audioUrl} onChange={(e) => setAudioUrl(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3" controlId="zoomUrl">
        <Form.Label>Zoom URL:</Form.Label>
        <Form.Control type="text" value={zoomUrl} onChange={(e) => setZoomUrl(e.target.value)} />
      </Form.Group>

      <Form.Group className="mb-3" controlId="type">
        <Form.Label>Type:</Form.Label>
        <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="AudioOnly">AudioOnly</option>
          <option value="ZoomOnly">ZoomOnly</option>
          <option value="Hybrid">Hybrid</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="dayOfWeek">
        <Form.Label>Day of Week:</Form.Label>
        <Form.Select value={dayOfWeek} onChange={(e) => setDayOfWeek(e.target.value)}>
          <option value="Sunday">Sunday</option>
          <option value="Monday">Monday</option>
          <option value="Tuesday">Tuesday</option>
          <option value="Wednesday">Wednesday</option>
          <option value="Thursday">Thursday</option>
          <option value="Friday">Friday</option>
          <option value="Saturday">Saturday</option>
          <option value="Everyday">Everyday</option>
          <option value="Weekday">Weekday</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="startTime">
        <Form.Label>Start Time:</Form.Label>
        <Form.Control type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} required />
      </Form.Group>

      <Form.Group className="mb-3" controlId="endTime">
        <Form.Label>End Time:</Form.Label>
        <Form.Control type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} required />
      </Form.Group>

      <Button variant="primary" type="submit">
        Create Session
      </Button>
    </Form>
  );
};

export default NewMeditation;
